import { Skeleton } from '@rbilabs/universal-components';
import {
  ProductSkeletonCardContainer,
  ProductSkeletonCardWrapper,
  ProductSkeletonCards,
  SkeletonCard,
  SkeletonCardContent,
} from 'features/menu/components/menu-product-skeleton/product-skeleton-card/styled';
import { StyleSheet } from 'react-native';

import {
  DEFAULT_PRODUCT_CARD_HEIGHT_DESKTOP,
  DEFAULT_PRODUCT_CARD_HEIGHT_MOBILE,
} from 'components/product-card/styled';
import { Box } from 'components/ui';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';

const SKELETON_CARDS_COUNT = 3;

export const ProductSkeletonCard = () => {
  const isMobile = useIsMobileBreakpoint();

  const skeletonCardHeight = isMobile
    ? DEFAULT_PRODUCT_CARD_HEIGHT_MOBILE
    : DEFAULT_PRODUCT_CARD_HEIGHT_DESKTOP;

  return (
    <ProductSkeletonCardWrapper>
      <ProductSkeletonCardContainer>
        <Skeleton width="1/3" h="$4" rounded="full" marginX="$2" />
        <ProductSkeletonCards>
          {Array.from({ length: SKELETON_CARDS_COUNT }).map((_, index) => (
            <SkeletonCard key={index} style={{ height: skeletonCardHeight }}>
              <SkeletonCardContent>
                <Box style={styles.cardImage}>
                  <Skeleton width="full" h="$4" rounded="md" flex={1} />
                </Box>
                <Box style={styles.cardContent}>
                  <Skeleton width="1/2" h="$4" rounded="md" />
                  <Skeleton width="full" h="$4" rounded="md" />
                </Box>
              </SkeletonCardContent>
            </SkeletonCard>
          ))}
        </ProductSkeletonCards>
      </ProductSkeletonCardContainer>
    </ProductSkeletonCardWrapper>
  );
};

const styles = StyleSheet.create({
  cardContent: {
    alignItems: 'center',
    height: 50,
    justifyContent: 'space-around',
  },
  cardImage: {
    flex: 1,
  },
});
